import React from 'react';
import Profile from '../components/Profile/index';

function ProfilePage() {
    return <Profile />;
}

export default ProfilePage;
